import axios from "axios";

// Automatically detect the environment and set the appropriate baseURL
const getBaseURL = () => {
  // In development the CRA dev server proxies /api to the backend (see
  // "proxy" in package.json), so localhost needs the explicit port.
  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5002/api";
  }

  // In production the backend serves the React build and the API from the
  // same origin, so a relative path works for any domain we deploy to.
  return "/api";
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000, // 30 second timeout instead of 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
